export default __webpack_public_path__ + "static/media/cv-img.38c4a70f.png";